/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Status_RejectedInputs */

const en_jobs_status_rejected = /** @type {(inputs: Jobs_Status_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejected`)
};

const de_jobs_status_rejected = /** @type {(inputs: Jobs_Status_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgelehnt`)
};

const fr_jobs_status_rejected = /** @type {(inputs: Jobs_Status_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refusé`)
};

const es_jobs_status_rejected = /** @type {(inputs: Jobs_Status_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechazado`)
};

const it_jobs_status_rejected = /** @type {(inputs: Jobs_Status_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rifiutata`)
};

const nl_jobs_status_rejected = /** @type {(inputs: Jobs_Status_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afgewezen`)
};

const pl_jobs_status_rejected = /** @type {(inputs: Jobs_Status_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odrzucono`)
};

const fi_jobs_status_rejected = /** @type {(inputs: Jobs_Status_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hylätty`)
};

const da_jobs_status_rejected = /** @type {(inputs: Jobs_Status_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afvist`)
};

const sv_jobs_status_rejected = /** @type {(inputs: Jobs_Status_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvisad`)
};

/**
* | output |
* | --- |
* | "Rejected" |
*
* @param {Jobs_Status_RejectedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_status_rejected = /** @type {((inputs?: Jobs_Status_RejectedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Status_RejectedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_status_rejected(inputs)
	if (locale === "fr") return fr_jobs_status_rejected(inputs)
	if (locale === "es") return es_jobs_status_rejected(inputs)
	if (locale === "it") return it_jobs_status_rejected(inputs)
	if (locale === "nl") return nl_jobs_status_rejected(inputs)
	if (locale === "pl") return pl_jobs_status_rejected(inputs)
	if (locale === "fi") return fi_jobs_status_rejected(inputs)
	if (locale === "da") return da_jobs_status_rejected(inputs)
	if (locale === "sv") return sv_jobs_status_rejected(inputs)
	return en_jobs_status_rejected(inputs)
});